import {registerExpressPaymentMethod} from '@woocommerce/blocks-registry';
import {getSettings, initStripe as loadStripe, isCartPage, isCheckoutPage} from "../util";
import {Elements, PaymentRequestButtonElement, useStripe} from "@stripe/react-stripe-js";
import {PaymentRequestPreview} from "./preview";
import PaymentRequestExpressCheckout from './paymentrequest-express-checkout';

const getData = getSettings('stripe_payment_request_data');

let cachedPromise = null;

const PaymentRequestContent = (props) => {
    const {
        getData,
        billing
    } = props;
    const {
        cartTotal,
        currency
    } = billing;
    let options = {
        mode: 'payment',
        paymentMethodCreation: 'manual',
        currency: currency?.code?.toLowerCase(),
        appearance: {
            variables: {
                borderRadius: getData('buttonRadius')
            }
        },
        ...getData('elementOptions')
    }
    if (0 >= cartTotal.value) {
        options = {...options, mode: 'setup'}
    }
    if (['payment', 'subscription'].includes(options.mode)) {
        options.amount = cartTotal.value;
    }
    return (
        <div className='wc-stripe-payment-request-container'>
            <Elements stripe={loadStripe} options={options}>
                <PaymentRequestExpressCheckout {...props}/>
            </Elements>
        </div>
    );
}

registerExpressPaymentMethod({
    name: 'stripe_payment_request_express',
    gatewayId: getData('gatewayId'),
    paymentMethodId: getData('gatewayId'),
    canMakePayment: (props) => {
        const {
            cart
        } = props;
        if (isCartPage() && !getData('cartCheckoutEnabled')) {
            return false;
        }
        if (isCheckoutPage() && !getData('expressCheckoutEnabled')) {
            return false;
        }

        if (cachedPromise !== null) {
            return cachedPromise;
        }

        let currency = cart.cartTotals.currency_code?.toLowerCase();
        if (!currency || currency?.length < 3) {
            currency = getData('currency')?.toLowerCase();
        }
        const total = parseInt(cart.cartTotals.total_price);
        cachedPromise = new Promise(resolve => {
            return loadStripe.then(stripe => {
                let options = {
                    mode: 'payment',
                    currency,
                }
                if (0 >= total) {
                    options = {...options, mode: 'setup'}
                }
                if (['payment', 'subscription'].includes(options.mode)) {
                    options.amount = total;
                }

                const element = stripe.elements(options);

                const expressCheckoutElement = element.create('expressCheckout', {
                    paymentMethods: {
                        googlePay: 'always'
                    }
                });
                expressCheckoutElement.on('ready', ({availablePaymentMethods}) => {
                    const {googlePay = false} = availablePaymentMethods || {};
                    expressCheckoutElement.unmount();
                    div.remove();
                    resolve(googlePay);
                });
                expressCheckoutElement.on('loaderror', () => {
                    div.remove();
                    resolve(false);
                });

                const div = document.createElement('div');
                div.style.display = 'none';
                document.querySelector('body').appendChild(div);

                expressCheckoutElement.mount(div);
            })
        });
        return cachedPromise;
    },
    content: <PaymentRequestContent getData={getData}/>,
    edit: <PaymentRequestPreview getData={getData}/>,
    supports: {
        showSavedCards: getData('showSavedCards'),
        showSaveOption: getData('showSaveOption'),
        features: getData('features')
    }
});